export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		region: '',
		culture: '',
	},
	COLLAPSE: {
		scenary: false,
	},
	LIST: {
		columns: {
			name: true,
			description: true,
		},
		rows: [],
	},
}